import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch book same day cleaning list data
export const getbookNowDetailList = createAsyncThunk(
  "bookNowDetailList/getbookNowDetailList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/cleaning/book_now_email`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const bookNowDetailSlice = createSlice({
  name: "bookNowDetailList",
  initialState: {
    loading: false,
    bookNowDetailData: null,
    error: null,
  },
  reducers: {
    ResetBookNowDetailState: (state) => {
      state.loading = false;
      state.bookNowDetailData = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getbookNowDetailList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getbookNowDetailList.fulfilled, (state, action) => {
        state.loading = false;
        state.bookNowDetailData = action.payload;
      })
      .addCase(getbookNowDetailList.rejected, (state, action) => {
        state.loading = false;
        state.bookNowDetailData = action.payload;
        state.error = action.payload;
      });
  },
});
export const { ResetBookNowDetailState } = bookNowDetailSlice.actions;
export default bookNowDetailSlice.reducer;
